import defaultConfig from '../default-config.json'
import { textLangs } from './consts'

const locationParts = window.location.hostname.split('.')
// 'cz' (ISO country code, what Czech users expect in a URL) is a public alias of the
// Czech site; internally the code is always 'cs' (ISO language code) — like 'us' → 'en'
const subDomain = locationParts[0] === 'cz' ? 'cs' : locationParts[0]

const getLangBySubdomain = () => {
  if (!defaultConfig.availableLang.includes(subDomain))
    return 'ua'

  return subDomain === 'us' ? 'en' : subDomain
}

// The persisted UI language if it's still a valid one, otherwise the subdomain default.
// Guards against a cleared/empty ("") or stale (old, removed) localStorage value — the
// previous `!= null` check accepted "" and left i18n / the store with no language.
export const getStoredLang = () => {
  const stored = localStorage.getItem('lang')
  return textLangs.includes(stored) ? stored : getLangBySubdomain()
}

export const getCountryBySubdomain = () => {
  if (!defaultConfig.availableLang.includes(subDomain))
    return 'ua'

  return subDomain
}

export default getLangBySubdomain